import classNames from 'classnames';
import * as React from 'react';

import { BlockSectionClassResolver } from '../../BlockSection/BlockSectionClassResolver';
import { LinkListColumnVariant } from './LinkListColumnVariant.csharp';
import { LinkListViewModel } from './LinkListViewModel.csharp';
import { LinkListWithColumns } from './LinkListWithColumns';
import { LinkListWithSwiper } from './LinkListWithSwiper';

export interface LinkListProps {
    model: LinkListViewModel;
}

export function LinkList(props: LinkListProps) {
    const {
        model,
        model: { heading, links, columnVariant, blockSectionMargin }
    } = props;

    return (
        <div className={classNames('LinkList', BlockSectionClassResolver.Resolve(blockSectionMargin))}>
            {heading && <h3 className="LinkList__Heading BlockSection__Heading">{heading}</h3>}

            {links && links.length > 0 && (
                <div className="LinkList__Content">
                    {columnVariant !== LinkListColumnVariant.List && <LinkListWithColumns model={model} />}
                    {columnVariant === LinkListColumnVariant.List && <LinkListWithSwiper model={model} />}
                </div>
            )}
        </div>
    );
}
